import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { FlightPlannerCard } from './ui/flight_planner_card.js';

/**
 * Entrada de catálogo do `flight_planner` (slot chat). Interativo: edição do
 * filtro (requery) e escolha de datas (search) voltam por `interaction` com
 * selections discriminado por `action` — o shell é só transporte; o map-guard
 * do flight (agents-v2) roteia sem LLM.
 *
 * `freezeWhenSupersededBy` (#4376), mesma régua do `hotel_planner`: as ofertas
 * são CONSEQUÊNCIA desta busca, e sob a régua de posição do shell elas
 * congelavam o card que as produziu — corrigir origem/destino exigia recomeçar a
 * jornada. O "Buscar" do card é fase-independente no agente (reinicia o ciclo e
 * busca de novo). Congelam só o planner MAIS NOVO (outra busca, inclusive o
 * reaberto por troca de rota em texto, que nasce com id próprio) e o
 * `product_checkout` (reserva em curso — ali uma busca nova descartaria a
 * reserva sem a confirmação que o texto pede).
 */
export const flightPlannerEntry: GenUiEntry<Extract<ChatUi, { kind: 'flight_planner' }>> = {
  kind: 'flight_planner',
  slot: 'chat',
  policy: {
    productOf: () => 'flight',
    // O card refaz o calendário via READ (`planner-preview`), sem turno — o
    // shell troca o bloco in-place. Nesse swap a nota do turno-âncora NÃO
    // acompanha: um card já preenchido não pode seguir exibindo a prosa antiga
    // (ex.: "preciso de origem/destino"); título/subtítulo descrevem o estado.
    previewOverride: true,
    noteOnOverride: false,
    freezeWhenSupersededBy: ['flight_planner', 'product_checkout'],
  },
  render: ({ ui, readOnly, superseded, busy, replay, dispatch }) => (
    <FlightPlannerCard
      ui={ui}
      readOnly={readOnly}
      superseded={superseded}
      busy={busy}
      replay={replay}
      dispatch={dispatch}
    />
  ),
};
